import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import EmbedLayout from '../../components/embed/EmbedLayout';
import VideoRoomWidget from '../../components/embed/VideoRoomWidget';
import { parseEmbedParams } from '../../utils/embedUtils';
import { mergeEmbedConfig } from '../../configs/EmbedConfig';

const VideoEmbed = () => {
  const [searchParams] = useSearchParams();
  const [config, setConfig] = useState({});
  const [roomCode, setRoomCode] = useState(null);

  useEffect(() => {
    initializeVideoEmbed();
  }, []);

  const initializeVideoEmbed = () => {
    try {
      // Get room code from URL parameter
      const code = searchParams.get('code');
      if (!code) {
        throw new Error('Room code is required');
      }
      setRoomCode(code);

      // Parse configuration from URL parameters
      const urlParams = parseEmbedParams();
      
      // Merge with default configuration
      const finalConfig = mergeEmbedConfig(urlParams);
      setConfig(finalConfig);
    } catch (error) {
      console.error('Video embed initialization failed:', error);
      setConfig({ error: error.message });
    }
  };

  const handleVideoCallEnd = () => {
    // Close the tab or redirect
    if (window.opener) {
      window.close();
    } else {
      // If opened directly, redirect to chat
      const chatUrl = new URL(window.location.href);
      chatUrl.pathname = '/embed/chat';
      chatUrl.searchParams.delete('code');
      window.location.href = chatUrl.toString();
    }
  };

  if (config.error) {
    return (
      <EmbedLayout config={config}>
        <div style={styles.errorContainer}>
          <div style={styles.errorTitle}>Error</div>
          <div style={styles.errorMessage}>{config.error}</div>
        </div>
      </EmbedLayout>
    );
  }

  if (!roomCode) {
    return (
      <EmbedLayout config={config}>
        <div style={styles.loadingContainer}>
          <div>Loading video room...</div>
        </div>
      </EmbedLayout>
    );
  }

  return (
    <EmbedLayout config={config}>
      <VideoRoomWidget
        code={roomCode}
        onCallEnd={handleVideoCallEnd}
        config={config}
        onError={(error) => {
          console.error('Video room error:', error);
        }}
      />
    </EmbedLayout>
  );
};

const styles = {
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    backgroundColor: '#fafafa',
    fontSize: '14px',
    color: '#666'
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '32px',
    textAlign: 'center',
    backgroundColor: '#fafafa'
  },
  errorTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '8px'
  },
  errorMessage: {
    fontSize: '14px',
    color: '#666',
    maxWidth: '300px',
    lineHeight: '1.5'
  }
};

export default VideoEmbed;

